import { NotificationPopup } from './NotificationPopup';
import { useNotifications } from '@/hooks/useNotifications';

export function NotificationContainer() {
  const { popupNotification, clearPopup, markAsRead } = useNotifications();

  const handleMarkAsRead = async () => {
    if (popupNotification) {
      await markAsRead(popupNotification.id);
    }
    clearPopup();
  };

  return (
    <NotificationPopup 
      notification={popupNotification}
      onClose={handleMarkAsRead}
    />
  );
}